import Analytics from 'packages/analytics';
import { logger } from 'packages/logger';
import locationUtils from 'tradera/utils/location';
import api from './api';
import { selectIsLoggedIn } from 'tradera/state/member/selectors';

/**
 * Sets new preferred language
 * @param {string} code - example: 'sv' or 'en'
 */
export const setPreferredLanguage =
    (code, toLocalizedUrl) => async (dispatch, getState) => {
        Analytics.trackEvent({
            category: 'Settings',
            action: 'Language',
            label: code
        });

        try {
            if (selectIsLoggedIn(getState())) {
                await api.saveLanguageSetting(code, toLocalizedUrl);
            }
            locationUtils.reloadLocalized(code);
        } catch (error) {
            logger(error);
        }
    };
